
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Add custom container class to global styles
if (typeof document !== 'undefined') {
  document.documentElement.style.setProperty('--container-custom', '1');
  
  const style = document.createElement('style');
  style.textContent = `
    .container-custom {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    @media (min-width: 640px) {
      .container-custom {
        max-width: 640px;
      }
    }
    @media (min-width: 768px) {
      .container-custom {
        max-width: 768px;
      }
    }
    @media (min-width: 1024px) {
      .container-custom {
        max-width: 1024px;
      }
    }
    @media (min-width: 1280px) {
      .container-custom {
        max-width: 1280px;
      }
    }
    @media (min-width: 1400px) {
      .container-custom {
        max-width: 1400px;
      }
    }
  `;
  document.head.appendChild(style);
}
